import { render, staticRenderFns } from "./zh.vue?vue&type=template&id=1ebc2a7a&scoped=true"
import script from "./zh.vue?vue&type=script&lang=js"
export * from "./zh.vue?vue&type=script&lang=js"
import style0 from "./zh.vue?vue&type=style&index=0&id=1ebc2a7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebc2a7a",
  null
  
)

export default component.exports